import { isImageSearchEnabled } from '@/core/utils/apiUtils';
import { IMAGE_SEARCH_API_URL, type ImageSearchEmbeddingResponse } from '../../constants';

export async function searchDesignsByImage(file: File): Promise<ImageSearchEmbeddingResponse> {
  if (!isImageSearchEnabled()) {
    throw new Error('Image search is disabled');
  }

  const formData = new FormData();
  formData.append('file', file, file.name);

  const res = await fetch(IMAGE_SEARCH_API_URL, {
    method: 'POST',
    body: formData,
    credentials: 'omit',
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Image search failed (${res.status}). ${text}`.trim());
  }

  return res.json() as Promise<ImageSearchEmbeddingResponse>;
}
